import { render, staticRenderFns } from "./hoverText.vue?vue&type=template&id=3207747f&scoped=true&"
import script from "./hoverText.vue?vue&type=script&lang=js&"
export * from "./hoverText.vue?vue&type=script&lang=js&"
import style0 from "./hoverText.vue?vue&type=style&index=0&id=3207747f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3207747f",
  null
  
)

export default component.exports